<template>
  <div>
    <CommonTable
      list-getter="projectMeteringStore/ingestionTariffStore/getList"
      create-item-dispatch="projectMeteringStore/ingestionTariffStore/create"
      update-item-dispatch="projectMeteringStore/ingestionTariffStore/update"
      delete-item-dispatch="projectMeteringStore/ingestionTariffStore/delete"
      :headers="headers"
      :slots="slots"
      :actions="actions"
      resource="ingestions"
      :static-dispatch-params="{
        project_id: $route.params.project_id,
        ingestion_id: $route.params.id
      }"
      :can-add="!readonly"
      :can-edit="!readonly"
      :can-delete="!readonly"
      @updated="updateList"
    ></CommonTable>
  </div>
</template>

<script>
import CommonTable from "../../../common/tables/CommonTable";
import { rules } from "../../../mixins/rules";
import { projectPermissions } from "../../../mixins/projects/projectPermissions";

export default {
  name: "TariffsIngestion",
  components: {
    CommonTable
  },
  mixins: [rules, projectPermissions],
  data: function() {
    return {
      headers: [
        {
          text: this.$t("ingestions.tariffs"),
          align: "left",
          value: "tariff_name"
        },
        {
          text: this.$t("ingestions.value-filter"),
          align: "left",
          value: "value_filter"
        },
        {
          text: this.$t("ingestions.action"),
          value: "action",
          align: "right",
          sortable: false
        }
      ],
      actions: []
    };
  },
  computed: {
    tariffs() {
      return this.$store.getters[
        "projectMeteringStore/tariffStore/getList"
      ].map(i => {
        i.value = i.id;
        i.text = i.name;
        return i;
      });
    },
    slots() {
      let rules = this.rules;
      return [
        {
          name: "tariff_name",
          type: "link",
          to: "tariff",
          title: "name",
          linkParams: {
            id: "id"
          },
          form: {
            type: "select",
            name: "id",
            items: this.tariffs,
            rules: [rules.required],
            newOnly: true,
            visible: true
          }
        },
        {
          name: "value_filter",
          title: "value-filter",
          form: {
            type: "value-filter-string",
            name: "value_filter",
            filterLabel: "value-filter",
            rules: [rules.required],
            visible: true,
            valueFilter: true,
            item: {
              _source: {
                id: 1
              }
            }
          }
        }
      ];
    },
    readonly: {
      get() {
        return !this.hasCurrentProjectPermissions("ingestion.update");
      }
    }
  },
  methods: {
    updateList() {
      this.$store.dispatch(
        "projectMeteringStore/ingestionTariffStore/getList",
        {
          params: {
            project_id: this.$route.params.project_id,
            ingestion_id: this.$route.params.id
          },
          onSuccess: () => {
            this.loading = false;
          }
        }
      );
    }
  },
  mounted() {
    this.updateList();
    this.$store.dispatch("projectMeteringStore/tariffStore/getList", {
      params: {
        project_id: this.$route.params.project_id,
        ingestion_id: this.$route.params.id,
        limit: -1
      },
      onSuccess: () => {
        this.loading = false;
      }
    });
  }
};
</script>
